var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 0H1.77778C0.8 0 0.00888888 0.8 0.00888888 1.77778L0 14.2222C0 15.2 0.8 16 1.77778 16H14.2222C15.2 16 16 15.2 16 14.2222V1.77778C16 0.8 15.2 0 14.2222 0ZM13.3333 9.77778H9.77778V13.3333H6.22222V9.77778H2.66667V6.22222H6.22222V2.66667H9.77778V6.22222H13.3333V9.77778Z",
    fill: "#656A6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocCross);
export default __webpack_public_path__ + "static/media/docCross.1147ba1704fba9954b4dda9b86e45c78.svg";
export { ForwardRef as ReactComponent };